let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1J4lt")).then(() => parcelRequire('cgboA'));